import { Box, Select } from '@chakra-ui/react';
import React, { useState } from 'react';

import { PriceFormat } from '@/app/_components/price-format/price-format';
import {
  SpecificationsPricesType,
} from '@/types/new-cars/new-cars.types';

import Styles from './variant-select.module.scss';

export const VariantsSelectNewCars: React.FC<{
  variants: SpecificationsPricesType[];
  setSelectedVariant?: (v: SpecificationsPricesType | null) => void;
  selectedVariant?: SpecificationsPricesType | null;
  disabled?: boolean;
  leadType?: string;
}> = ({ variants, setSelectedVariant, selectedVariant, disabled = false, leadType }) => {
  let price = '0';

  if (selectedVariant?.price) {
    const priceNumberWord = String(selectedVariant.price);

    if (parseFloat(selectedVariant.price) > 3) {
      price = `${priceNumberWord.slice(0, -3)} ${priceNumberWord.slice(-3)}`;
    } else {
      price = priceNumberWord;
    }
  }

  // use mm_code (or id) consistently
  const [variantValue, setVariantValue] = useState(
    selectedVariant?.mm_code ?? '',
  );

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value; // mm_code
    const selected =
      variants.find((obj) => obj.mm_code === value) || null;

    setVariantValue(value);
    setSelectedVariant?.(selected);
  };

  return (
    <>
      <Box className={Styles.customSelect}>
        <Select
          className={Styles.formInput}
          placeholder="Select variant"
          variant="flushed"
          onChange={handleChange}
          disabled={disabled}
          value={variantValue}
          aria-label="select variant"
        >
          {variants?.map((item) => (
            <option key={item.mm_code} value={item.mm_code}>
              {item.title}
            </option>
          ))}
        </Select>
      </Box>

      {selectedVariant && selectedVariant.title.length > 1 && leadType !== 'corporate' && (
        <div className={Styles.variantDetails}>
          <div className={Styles.variantMain}>
            <span className={Styles.variantTitle}></span>
            <span className={Styles.variantPrice}>
              <PriceFormat prefix="R" value={price} />
            </span>
          </div>
        </div>
      )}
    </>
  );
};

